<template>
  <div class="accounts-container">
    <div class="operation-bar">
      <el-button type="primary" size="mini" @click="handleCreate">创建用户</el-button>
      <el-button type="danger" size="mini" @click="handleBatchDelete" :disabled="!selectedRows.length"
        >批量删除</el-button
      >
      <div class="search-box">
        <el-input v-model="searchTerm" placeholder="请输入用户名称" style="width: 200px" size="mini" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="margin-left: 10px" size="mini" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="role" label="角色" width="120">
        <template slot-scope="scope">
          <el-tag v-for="item in scope.row.roles" size="mini" :key="item.id" type="primary">{{ item.roleName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="用户名称"></el-table-column>
      <el-table-column prop="username" label="登录账号/手机号"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" style="color: #2680dd" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <!-- 创建用户弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="formData.roleId" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in roleOptions" :key="item.roleId" :label="item.roleName" :value="item.roleId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="formData.nickName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="formData.username" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="formData.password" type="password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formData.phone" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';
import { encryptData } from '@/utils/AES';
export default {
  name: 'AccountsManagement',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      searchTerm: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      roleOptions: [],
      dialogTitle: '创建用户',
      formData: {
        userId: '', // 添加userId字段
        roleId: '',
        nickName: '',
        username: '',
        password: '',
        phone: '',
      },
      isEdit: false, // 添加编辑状态标识
      rules: {
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        nickName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入登录密码'));
              } else if (value.length < 8) {
                callback(new Error('密码长度不能少于8位'));
              } else if (!/(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9])/.test(value)) {
                callback(new Error('密码需包含字母、数字和特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          searchTerm: this.searchTerm,
        };
        const res = await axios.post(baseUrl + '/api/system/user/page', params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error('获取用户列表失败:', error);
      }
    },

    // 选择行变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },

    // 获取角色列表
    async fetchRoleList() {
      try {
        const res = await axios.post(baseUrl + '/api/system/role/list');
        if (res.code === 200) {
          this.roleOptions = res.data || [];
        }
      } catch (error) {
        console.error('获取角色列表失败:', error);
      }
    },

    // 打开创建用户弹窗
    handleCreate() {
      this.isEdit = false;
      this.dialogTitle = '创建用户';
      this.dialogVisible = true;
      this.fetchRoleList();
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
      });
    },

    // 打开编辑用户弹窗
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑用户';
      this.dialogVisible = true;
      this.fetchRoleList();
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        // 填充表单数据
        Object.keys(this.formData).forEach((key) => {
          if (key === 'password') {
            this.formData[key] = ''; // 密码不回填
          } else if (key === 'roleId') {
            this.formData[key] = row.roles && row.roles.length ? row.roles[0].roleId : '';
          } else {
            this.formData[key] = row[key];
          }
        });
        this.formData.userId = row.userId; // 设置用户ID
      });
    },

    // 关闭弹窗
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.isEdit = false;
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = '';
      });
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.formData,
          };

          // 兼容后端要求，roleId 转为 roleIds 数组
          params.roleIds = [this.formData.roleId];
          delete params.roleId;

          // 加密用户名和密码
          params.username = encryptData(this.formData.username);
          if (this.formData.password) {
            // 编辑时可能不修改密码
            params.password = encryptData(this.formData.password);
          } else {
            delete params.password; // 如果密码为空，则不传递该字段
          }

          try {
            const url = this.isEdit ? '/api/system/user/update' : '/api/system/user/save';
            const res = await axios.post(baseUrl + url, params);
            if (res.code === 200) {
              this.$message.success(this.isEdit ? '更新成功' : '创建成功');
              this.dialogVisible = false;
              this.fetchData();
            }
          } catch (error) {
            console.error(this.isEdit ? '更新用户失败:' : '创建用户失败:', error);
          }
        }
      });
    },

    // 删除用户
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        axios
          .post(baseUrl + '/api/system/remove', {
            id: row.id,
          })
          .then((res) => {
            this.$message.success('删除成功');
            this.fetchData();
          });
        // TODO: 调用删除接口
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除用户失败:', error);
        }
      }
    },

    // 批量删除
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个用户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        axios
          .post(
            baseUrl + '/api/system/user/removeBatch',
            this.selectedRows.map((row) => row.id)
          )
          .then((res) => {
            this.fetchData();
          });
        // TODO: 调用批量删除接口
      } catch (error) {
        if (error !== 'cancel') {
          console.error('批量删除用户失败:', error);
        }
      }
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 页码变化
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.accounts-container {
  padding: 20px;

  .operation-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .search-box {
      margin-left: auto;
    }
  }

  .delete-button {
    color: #f56c6c;
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
